import { useApiClient } from '@m43/core';
import {
    ApiResultClearEventResponse,
    ClearEventForm,
    ClearEventFormType,
    ClearEventResource,
} from '@mark43/cad-api';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios-cad-nx';

export function useClearEventMutation({
    onMutationSuccess,
}: {
    onMutationSuccess: (data: AxiosResponse<ApiResultClearEventResponse>) => void;
}) {
    const apiClient = useApiClient();

    const mutation = useMutation(
        (clearEventFormValues: ClearEventFormType) => {
            return apiClient.request<ClearEventResource.ClearEventModal>({
                method: 'POST',
                url: 'clear_event/',
                data: clearEventFormValues as ClearEventForm,
            });
        },
        {
            onSuccess(data) {
                onMutationSuccess(data);
            },
        }
    );

    return mutation;
}
